<template>
    <div class="clearfix" id="like-box">
        <nav-header></nav-header>
        <div class="row mx-0">
            <div class="home-swiper-box">
                <img src="../../public/images/like.png" alt="" />
            </div>
        </div>
        <div class="like-content-box">
            <div class="like-desc-box">
                <div v-for="(item,key) in descData" :key="key" class="clearfix like-common-desc">
                    <div class="like-common-left">
                        {{item.name}}
                    </div>
                    <div v-html="item.desc" class="like-common-right"></div>
                </div>
            </div>
            <div class="like-sub-title">
                有梦想,一起拼
            </div>
            <div class="like-invite-box">
                <div v-for="(item,key) in inviteData" :key="key"  class="clearfix like-common-invite">
                    <div class="like-common-left">
                        <div class="like-invite-circle">
                            <p>{{item.post}}</p>
                            <p>{{item.acronym}}</p>
                        </div>
                    </div>
                    <div v-html="item.desc"  class="like-common-right"></div>
                </div>
            </div>
            <div class="like-sure-box">
                <p>Are you interested in ?</p>
                <p>简历及作品请发送至：<a href="mailto:;" target="_blank">SHICHA@163.COM</a></p>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
// @ is an alias to /src
import NavHeader from "@/components/navHeader.vue";
import Footer from "@/components/footer.vue";

export default {
    name: "like",
    components: {
        NavHeader,
        Footer
    },
    data() {
        return {
            //描述数据
            descData: [
                {
                    name: "你真正喜欢设计吗",
                    desc: "我们坚持“工作并快乐着”，每天从事自己不喜欢的工作是件很郁闷的事，<br>那就更谈不上什么大展身手了，只有喜欢，才能做好。<br>在这里需要创作性头脑，需要有研究精神，只有你全身心的投入，才能创造经典。"
                },
                {
                    name: "你有设计师的意识",
                    desc: "设计不只是艺术，有品质也得有价值，做对设计才是最重要的。"
                },
                {
                    name: "能成为我们的伙伴",
                    desc: "物以类聚，人以群分。在这里，我们有着共同的追求才能能融为一个团队，<br>如果你在这里感到轻松的、和谐的、愉悦的。那就说明我们已经是朋友了。"
                },
                {
                    name: "有追求才有进取",
                    desc: "快速学习，虚心请教，认真钻研，看一大堆子书，不犯同样的错误。<br>主动学习是我们对整个团队的要求，也是对每个设计师的要求。"
                }
            ],
            //招聘内容
            inviteData: [
                {
                    post: "平面设计师",
                    desc: "年龄：35岁以下 <br>性别：不限 <br>学历：不限 <br>工作经验：3-5年<br>招聘人数：不限 <br>任职要求： <br>A、精通CorelDraw，Photoshop，Illustrator等常用设计排版软件。<br> B、能独立完成各类平面设计（产品样本、公司宣传册、LOGO、海报、户外广告、产品包装、CI企业形象策划等）的设计制作。 <br>C、能独立完成设计任务,听从指挥,能吃苦耐劳。 <br>D、有相关工作经验者优先。<br>",
                    acronym: "GRAPHIC  DESIGNER"
                },
                {
                    post: "展厅空间设计师",
                    desc: "年龄：35岁以下 <br>性别：不限 <br>学历：不限 <br>工作经验：3-5年<br>招聘人数：2名 <br>任职要求： <br>A、相关专业大专以上学历，性别不限，有展览展示设计经验。 <br>B、有较强的责任心、事业心、工作态度稳定；为人坦诚，容易沟通。 <br>C、熟练运用3Dmax，Photoshop，Autocad，CorelDRAW等必备软件。<br>D、思维敏捷、具有较高的艺术修养和品位，善于沟通，能准确完整的表达自己的设计思路善于运用新兴的展示手段与素材，具有较强的创新能力。",
                    acronym: "SPACE  DESIGNER"
                },
                {
                    post: "实习生",
                    desc: "A、大学本科学历，美术、平面设计或相关专业； <br>B、精通photoshop、illustartor、indesign,有良好的视觉语言基础；<br>C、热爱设计事业、具有钻研精神、具备良好合作态度及团队精神，并富有工作激情、和责任感。",
                    acronym: "TRAINEE"
                }
            ]
        };
    },
    created() {},
    methods: {},
    mounted() {
    }
};
</script>
<style lang="scss" scoped>
#like-box {
    margin-top: 80px;
    overflow: hidden;

    .home-swiper-box {
        width: 100%;
        overflow: hidden;
        position: relative;

        img {
            width: 100%;
            // height: 700px;
        }
    }

    .like-content-box {
        width: 1200px;
        margin: 0 auto;

        .like-desc-box {
            margin-top: 85px;

            .like-common-desc {
                margin-bottom: 70px;
                height: 65px;

                .like-common-left {
                    background: url('../../public/images/icon1.png') right 50px center no-repeat;
                    background-size: 7px 62px;
                    color: #333333;
                    font-size: 24px;   
                    padding-right: 110px;
                }
            }
        }

        .like-invite-box {
            .like-common-invite {
                height: 250px;
                margin-bottom: 120px;

                .like-common-left {
                    .like-invite-circle {
                        background: #fff;
                        width: 222px;
                        height: 222px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 24px;
                        line-height: 24px;
                        flex-direction: column;
                        color: #cc0000;
                        border: 1px dotted #cc0000;

                        p {
                            // color: #fff;
                            margin: 0;

                            &:last-child {
                                // color: #66ffff;
                                font-size: 12px;
                            }
                        }
                    }
                }
            }
        }

        .like-sure-box {
            margin-bottom: 200px;
            color: #cc0000;
            line-height: 24px;
            font-size: 56px;

            p:last-child {
                font-size: 20px;
                margin-top: 40px;
                color: #999999;

                a {
                    color: #999;
                    text-decoration: none;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
        .like-common-left {
            width: 505px;
            float: left;
            display: flex;
            align-items: center;
            height: 100%;
            justify-content: flex-end;
            padding-right: 110px;
        }

        .like-common-right {
            display: flex;
            align-items: center;
            width: 695px;
            float: right;
            color: #333333;
            font-size: 14px;
            line-height: 24px;
            text-align: left;
            height: 100%;
        }

        .like-sub-title {
            color: #cc0000;
            font-size: 56px;
            line-height: 24px;
            margin: 0 auto 155px;
            padding-top: 70px;  
        }
    }
}

@media screen and (max-width: 1260px){
    #like-box  {
        .like-content-box {
            width: auto;
            margin: 0 20px;
        }
    }
}
</style>
